import {defaultLocale} from '@/i18n/config'
import React, {useEffect} from 'react'

interface Props {
  locale?: string
}

// 'Contact Us' Hubspot form
const formConfigByLocale: Record<string, {formId: string; portalId: string}> = {
  en: {
    portalId: '8444102',
    formId: '95902140-3372-4e4b-ae04-596cf49bcf18',
  },
  sv: {
    portalId: '8444102',
    formId: '40d55da5-3cc0-4e44-b314-33b8031c94ad',
  },
  no: {
    portalId: '8444102',
    formId: '694972a1-6669-4544-be63-d2cd9f74f11d',
  },
  da: {
    portalId: '8444102',
    formId: '4990043d-dd68-4360-80d8-5003c7719200',
  },
  es: {
    portalId: '8444102',
    formId: '6fd34bda-92a9-4661-a18c-a6cc4c34d72d',
  },
  pt: {
    portalId: '8444102',
    formId: '21aa7d4e-19c2-49ea-9cc2-cc7237979fec',
  },
}

export const HubspotContactForm: React.FC<Props> = ({locale}) => {
  const formConfig = locale ? (formConfigByLocale[locale] ?? formConfigByLocale[defaultLocale]) : formConfigByLocale[defaultLocale]

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js' // HubSpot forms library
    script.async = true

    script.onload = () => {
      /* eslint-disable @typescript-eslint/no-explicit-any */
      if (window.hbspt as any) {
        // @ts-expect-error hbspt is defined in the script above.
        window.hbspt.forms.create({
          ...formConfig,
          target: '#hubspotForm', // The target div where the form will render
        })
      }
      /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [formConfig, locale])

  return <div id="hubspotForm"></div> // Container for the HubSpot form
}
